import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { Table, Tooltip, Checkbox, Button } from "antd";
import { ColumnProps, SortOrder } from "antd/es/table";
import {
    FilterListItem,
    TableItem
} from "../../../../../../service/experiment";
import moment from "moment";
import { FilterDropdownProps } from "antd/es/table/interface";

interface StuTableProps {
    data: TableItem[];
    loading: boolean;
    selectData: TableItem[];
}

export default function StuTable({ data, loading, selectData }: StuTableProps) {
    const [filterList, setFilterList] = useState<FilterListItem[]>([]); // 筛选项
    const sortDirections: SortOrder[] = ["descend", "ascend"];

    //筛选项list
    useEffect(() => {
        if (selectData) {
            const filters = selectData.map(item => ({
                text: {
                    courseName: item.courseName,
                    courseSeq: item.courseSeq,
                    courseNo: item.courseNo
                },
                value: `${item.courseNo}-${item.courseSeq}`,
                isChecked: false
            }));
            setFilterList(filters);
        }
    }, [selectData]);

    function onChange(
        e: any,
        item: FilterListItem,
        index: number,
        setSelectedKeys?: (selectedKeys: string[]) => void
    ) {
        let newFilter: any = [...filterList];
        newFilter[index].isChecked = e.target.checked;
        setFilterList(newFilter);
        setSelectedKeys &&
            setSelectedKeys(
                newFilter
                    .filter((item: any) => item.isChecked === true)
                    .map((item: FilterListItem) => item.value)
            );
    }

    //筛选重置事件
    const handleReset = (clearFilters?: () => void) => {
        clearFilters && clearFilters();
        setFilterList(filterList.map(item => ({ ...item, isChecked: false })));
    };

    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown:
            data.length !== 0
                ? ({
                      setSelectedKeys,
                      selectedKeys,
                      confirm,
                      clearFilters
                  }: FilterDropdownProps) => (
                      <div style={{ padding: 8 }}>
                          {filterList.map(
                              (
                                  item: FilterListItem,
                                  index: number //筛选项循环
                              ) => (
                                  <div
                                      key={item.value}
                                      className={style.filterItem}>
                                      <Checkbox
                                          onChange={e =>
                                              onChange(
                                                  e,
                                                  item,
                                                  index,
                                                  setSelectedKeys
                                              )
                                          }
                                          checked={item.isChecked}>
                                          <div className={style.inline}>
                                              <div className={style.courseName}>
                                                  <Tooltip
                                                      title={
                                                          item.text.courseName
                                                      }>
                                                      {item.text.courseName}
                                                  </Tooltip>
                                              </div>
                                              <div className={style.courseInfo}>
                                                  编号:{item.text.courseNo}
                                                  &nbsp;&nbsp;序号
                                                  {item.text.courseSeq}
                                              </div>
                                          </div>
                                      </Checkbox>
                                  </div>
                              )
                          )}
                          <div className={style.btn}>
                              <Button
                                  type="link"
                                  onClick={confirm}
                                  size="small">
                                  确定
                              </Button>
                              <Button
                                  type="link"
                                  onClick={() => handleReset(clearFilters)}
                                  size="small">
                                  重置
                              </Button>
                          </div>
                      </div>
                  )
                : false
    });

    const columns: ColumnProps<TableItem>[] = [
        {
            title: "序号",
            key: "index",
            align: "center",
            width: 100,
            render: (text, item, index) => index + 1
        },
        {
            title: "课程信息",
            dataIndex: "courseInfo",
            align: "center",
            width: 200,
            ...getColumnSearchProps("courseNo"),
            render: text => (
                <div>
                    <div className={style.courseName}>
                        <Tooltip title={text.courseName}>
                            {text.courseName}
                        </Tooltip>
                    </div>
                    <div className={style.courseInfo}>
                        编号:{text.courseNo}&nbsp;&nbsp;序号{text.courseSeq}
                    </div>
                </div>
            ),
            onFilter: (value: string, record: TableItem) => {
                return `${record.courseInfo.courseNo}-${record.courseInfo.courseSeq}`.includes(
                    value
                );
            }
        },
        {
            title: "开始时间",
            dataIndex: "BeginDay",
            align: "center",
            width: 200,
            sortDirections: sortDirections,
            sorter: (a: any, b: any) => {
                a = a.BeginDay === "" ? 0 : a.BeginDay;
                b = b.BeginDay === "" ? 0 : b.BeginDay;
                return moment(a).diff(b);
            }
        },
        {
            title: "结束时间",
            dataIndex: "EndDay",
            align: "center",
            width: 200,
            sortDirections: sortDirections,
            sorter: (a: any, b: any) => {
                a = a.EndDay === "" ? 0 : a.EndDay;
                b = b.EndDay === "" ? 0 : b.EndDay;
                return moment(a).diff(b);
            }
        },
        {
            title: "预约数量",
            dataIndex: "Used",
            align: "center"
        },
        {
            title: "剩余数量",
            dataIndex: "Total",
            align: "center"
        }
    ];

    return (
        <div className={style.root}>
            <Table
                columns={columns}
                loading={loading}
                rowKey="key"
                dataSource={data}
                pagination={false}
                scroll={{ y: 375 }}
            />
        </div>
    );
}
